import styled, { useTheme } from "styled-components";
import { Breakpoint } from "../../../enums/Breakpoint";
import { useMemo } from "react";
import useMedia from "../../../hooks/useMedia";
import Checkmark from "../../../customIcons/Checkmark";
import Mk1Typography from "../Mk1Typography";
import { useTranslation } from "../../../i18n";
import { SearchFormTabValues } from "../../../enums/SearchFormTabValues";

interface Props {
  productType: SearchFormTabValues;
}

const ExternalLayoutPerks = ({ productType }: Props) => {
  const isMaxTinyMobile = useMedia(Breakpoint.MaxTinyMobile);
  const isMaxSmallMobile = useMedia(Breakpoint.MaxSmallMobile);
  const isMaxMobile = useMedia(Breakpoint.MaxMobile);
  const { t } = useTranslation();
  const theme = useTheme();

  const perksLabels = useMemo(() => {
    const productTypePerksLabels = [
      `tix_search_form_${productType}_perk_1`,
      `tix_search_form_${productType}_perk_2`,
      `tix_search_form_${productType}_perk_3`,
    ];
    const numberOfPerksShown = isMaxTinyMobile ? 1 : isMaxSmallMobile ? 2 : 3;
    const labels = isMaxMobile
      ? productTypePerksLabels.slice(0, numberOfPerksShown)
      : productTypePerksLabels;
    return labels.map((label) => t(label));
  }, [isMaxMobile, t, isMaxTinyMobile, isMaxSmallMobile, productType]);

  return (
    <Perks>
      {perksLabels.map((translation, index) => (
        <PerkContainer color="" key={index}>
          <Checkmark stroke={theme.checkmarkColor} />
          <StyledLabel defaultVariant="small"> {translation}</StyledLabel>
        </PerkContainer>
      ))}
    </Perks>
  );
};

const StyledLabel = styled(Mk1Typography)`
  line-height: 17px;
  margin: auto;
`;

const Perks = styled.div`
  background: ${({ theme }) => theme.darkBackground};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;

  @media ${Breakpoint.MaxMobile} {
    ${({ theme }) =>
      !!theme.form.container?.mobileBackgroundColor &&
      `background: ${theme.form.container?.mobileBackgroundColor};`}
  }
`;

const PerkContainer = styled.div`
  display: flex;

  &:not(:last-child) {
    margin-right: 30px;
  }

  svg {
    margin: 2px 5px 0 0;
  }
`;

export default ExternalLayoutPerks;
